import { getBaseURL } from '../../../../../GlobalComponents/URLs'

export const handleAssemblyIDSearch = async (
    uValue,
    data,
    setApiData,
    setIsAssemblySearchModalVisible,
    setAssemblyError
) => {
    try {
        const orderNumber = data.FormSectionFieldValueView.find(
            (x) => x.FieldNameQuery.trim().toUpperCase() === 'ORDERNUMBER'
        )?.StringFieldValue
        let url = ''
        console.log(orderNumber)
        if (orderNumber != '' && orderNumber != null) {
            url = `${getBaseURL()}webapi/form/GetAWCAssemblyInfo/${uValue}/${orderNumber}`
        } else {
            url = `${getBaseURL()}webapi/form/GetAWCAssemblyInfo/${uValue}`
        }
        const response = await fetch(url, {
            method: 'GET', // Use 'POST' or other methods as required
            headers: {
                'Content-Type': 'application/json',
                // Add any other headers you need, such as authorization tokens
            },
            credentials: 'include',
        })

        // Check if the response is successful
        if (!response.ok) {
            throw new Error(`API call failed with status: ${response.status}`)
        }

        const responseData = await response.json() // Parse the JSON data from the response
        if (responseData.ErrorMessage) {
            setAssemblyError(responseData.ErrorMessage)
        } else {
            setApiData(responseData) // Set the API data to state
            setIsAssemblySearchModalVisible(true)
        }
    } catch (error) {
        setAssemblyError('An error occurred, please check your sales order') // Update the error state to display any errors
    }
}

export const handleAssembliesList = async (uValue, setAWCAssemblyUIDList, setAssemblyError) => {
    try {
        const requestData = {
            AWCAssemblyID: uValue,
        }
        const response = await fetch(
            `${getBaseURL()}webapi/form/GetCustomerAWCAssemblyIDsListByAWCAssemblyID`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Add any other headers you need, such as authorization tokens
                },
                credentials: 'include',
                body: JSON.stringify(requestData),
            }
        )

        // Check if the response is successful
        if (!response.ok) {
            throw new Error(`API call failed with status: ${response.status}`)
        }

        const responseData = await response.json()
        const sortedItems = [...responseData.AWCAssemblyIDList].sort(
            (a, b) => new Date(a.SalesOrderDate) - new Date(b.SalesOrderDate)
        )
        setAWCAssemblyUIDList(sortedItems)
    } catch (error) {
        console.error('Error fetching data:', error.message)
        setAssemblyError(error.message) // Update the error state to display any errors
    }
}

export const handleAssemblyIDSelection = async (
    data,
    setAWCAssemblyUIDList,
    setData,
    setAssemblyInfo,
    setAssemblyError,
    handleSubmitWithData,
    poNumber,
    setPOModalVisible,
    isPOModalVisible,
    setShowAssemblyListModal
) => {
    const orderNumber = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'ORDERNUMBER'
    )?.StringFieldValue

    const invalidSerialNumbers = ['', 'N/A', 'NA', 'n/a', 'na', 'None', 'NONE','TBD','tbd','COMPLETED','NO SERIAL']

    const serialNumber = data.FormSectionFieldValueView.find(
        (x) =>
            x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBER' &&
            x.StringFieldValue &&
            !invalidSerialNumbers.includes(x.StringFieldValue.trim().toUpperCase())
    )?.StringFieldValue

    const serialNumberOriginal = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBERORIGINAL'
    )?.StringFieldValue

    const tagNumber = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'TAGNUMBER'
    )?.StringFieldValue

    const finalSerialNumber = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'FINALSERIALNUMBER'
    )?.StringFieldValue

    // Check if OrderNumber is empty or undefined
    if (!orderNumber) {
        setAssemblyError('Order number is missing.')
        return
    }

    let requestData = {
        OrderNumber: orderNumber,
        SerialNumber: serialNumber,
        TagNumber: '',
        AssetType: data.OrderInfo[0].CustomerAssetType,
    }

    let url = `${getBaseURL()}webapi/form/GetCustomerAWCAssemblyIDsListBySerialNumberOrderNumber`

    try {
        if (serialNumber) {
        } else {
            if (serialNumberOriginal && serialNumberOriginal?.trim() != '') {
                requestData.serialNumberOriginal = serialNumberOriginal
                url = `${getBaseURL()}webapi/form/GetAWCIDFromOEM`
            } else {
                if (tagNumber) {
                    requestData.TagNumber = tagNumber
                } else {
                    if (poNumber) {
                        requestData.PoNumber = poNumber
                        url = `${getBaseURL()}webapi/form/GetAWCIDFromPO`
                    } else {
                        setPOModalVisible(true)
                        return
                    }
                }
            }
        }

        if (finalSerialNumber) {
            requestData.SerialNumber = finalSerialNumber
            url = `${getBaseURL()}webapi/form/GetCustomerAWCAssemblyIDsListBySerialNumberOrderNumber`
        }
    } catch (error) {
        console.log(error)
        setAssemblyError('We had an error trying to get the information to look for an AWCID')
        return
    }
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(requestData),
    })
    if (!response.ok) {
        setAssemblyError('Cannot provide an AWC ID')
        throw new Error(`API call failed with status: ${response.status}`)
    }

    const responseData = await response.json()
    if (responseData.ErrorMessage) {
        setAssemblyError(responseData.ErrorMessage)
    }
    const sortedItems = responseData?.AWCAssemblyIDList
        ? [...responseData.AWCAssemblyIDList].sort(
              (a, b) => new Date(a.SalesOrderDate) - new Date(b.SalesOrderDate)
          )
        : []

    setAWCAssemblyUIDList(sortedItems)
    setData((data) => {
        const tagUIDField = data.FormSectionFieldValueView.find(
            (d) => d.FieldNameQuery === 'TagUID'
        )
        const tempAwcIdField = data.FormSectionFieldValueView.find(
            (d) => d.FieldName === 'TempAwcId'
        )
        tagUIDField.NumericFieldValue = responseData?.AWCAssemblyID ?? ''
        tempAwcIdField.BooleanFieldValue = responseData?.TempAwcId ?? false
        data.OrderInfo[0].AWCAssemblyId = tagUIDField.NumericFieldValue
        return { ...data }
    })
    if (responseData?.TempAwcId) {
        setShowAssemblyListModal(true)
    }
    setAssemblyInfo(responseData?.Message)
    handleSubmitWithData(data)
}

export const handleCreateNewUidClick = (data, setData, setAssemblyError) => {
    const orderNumber = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'ORDERNUMBER'
    )?.StringFieldValue

    const serialNumber = data.FormSectionFieldValueView.find(
        (x) =>
            x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBER' ||
            x.FieldNameQuery.trim().toUpperCase() === 'SERIALNUMBERORIGINAL'
    )?.StringFieldValue

    const tagNumber = data.FormSectionFieldValueView.find(
        (x) => x.FieldNameQuery.trim().toUpperCase() === 'TAGNUMBER'
    )?.StringFieldValue

    // Check if OrderNumber is empty or undefined
    if (!orderNumber) {
        setAssemblyError('Order number is missing.')
        return
    }

    const requestData = {
        OrderNumber: orderNumber,
        SerialNumber: serialNumber,
        Tag: tagNumber,
        AssetType: data.OrderInfo.CustomerAssetType,
    }
    let url = `${getBaseURL()}/webapi/form/createtaguid`

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(requestData),
    })
        .then((response) => {
            if (response.ok) return response.json()

            return response.text()
        })
        .then((results) => {
            if (typeof results === 'string') throw Error(results)
            setData((data) => {
                data.FormSectionFieldValueView.find(
                    (d) => d.FieldNameQuery === 'TagUID'
                ).NumericFieldValue = results
                return { ...data }
            })
        })
        .catch((error) => {
            console.log(error)
            setAssemblyError('We encounter an issue trying to create a new AWCID')
        })
}
